import ViewFactory from '../../../packages/creator/index'
import Schema from '../../../packages/helper/schema'
import { ROLE } from '../../helper/valueMap'
import renderStatus from '../../helper/renderStatus'
import CollectionDescriptor from '../../../packages/helper/resource'
import { MODE } from '../../../packages/constant';

export default ViewFactory({
  name: 'Normal View',
  mode: MODE.EDIT_IN_TABLE,
  data: new CollectionDescriptor('role'),
  schema: [
    new Schema.Input('Role ID', 'role_id', false, {
      editable: false,
      asFilter: true,
      render: (value, row) => row['id']
    }),
    new Schema.Input('Role Name', 'name', true),
    new Schema.Select('Status', 'status', [
      ...ROLE.STATUS.map((item, index) => ({
        label: item,
        value: index
      }))
    ], true, {
      asFilter: true,
      render: (value) => renderStatus({
        type: ROLE.STATUS_CLASS[value],
        content: ROLE.STATUS[value]
      })
    }),
    new Schema.Datetime('Create Time', 'ctime', false, {
      editable: false
    }),
    new Schema.Tree('Permission', 'permission_list', state => state.user.permissionTree, true, {
      editable: true,
      inTable: false,
      asFilter: false
    })
  ],
  actions: [
    'edit'
  ],
  hooks: [
    {
      label: 'test',
      handler: ($router, $route) => {

      }
    }
  ],
  options: {
    columnEditable: true
  }
})



// WEBPACK FOOTER //
// ./examples/views/lists/normal.js